import ExclusionZonePage from '../CRUDUtils/ExclusionZonePage';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function NewZonesPage() {

  const { deployment_id, location_name } = useParams()

  const site_name = "Site: " + location_name

  return (
    <div className='container-wrapper'>
      <ExclusionZonePage
        key={deployment_id}
        deployment_key={deployment_id}
        modesEndpoint = {`read/detectionpackages?deployment_id=${deployment_id}`}
        exclusionZonesEndpoint = "read/exclusionzones"
        imageEndpoint = "read/images"
        saveZoneEndpoint = "create/exclusionzones"
        deleteZoneEndpoint = "delete/exclusionzones"
        streamsEndpoint={`read/streams?deployment_id=${deployment_id}`}
        location_name={site_name}
      />
    </div>
  );
}